module.exports = __webpack_public_path__ + "public/img/storage_tianchong.c29a7638.png";